import React, { useId, useState } from 'react';
import Icon from "../icons/Icon";
import Modal from "./Modal";
import '../../styles/components/modals.css';

const CompletePayrollModal = ({ isOpen, onClose, onConfirm, payrollRun, summaryTotals, companyId, company }) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const titleId = useId();

  if (!isOpen) return null;

  const handleOK = async () => {
    setLoading(true);
    setStatus('Submitting payroll for approval...');

    try {
      // Submit the payroll for approval — payrollCompletionService.approvePayroll
      // performs the deduction write-back at approval time.
      onConfirm({});

      setTimeout(() => {
        setStatus('Payroll submitted for approval!');
      }, 500);
    } catch (error) {
      console.error('Error in payroll submission:', error);
      setStatus('Error submitting payroll. Please try again.');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // busy stays false: `loading` here is a 1s cosmetic timer, and the parent
  // closes this modal as soon as onConfirm runs (PRD_ModalBehavior C4 table).
  return (
    <Modal isOpen={isOpen} onClose={onClose} labelledBy={titleId} className="modal-content modal-complete-payroll">
        <div className="modal-header">
          <h3 id={titleId}>Submit Payroll for Approval</h3>
        </div>

        <div className="modal-body">
          <div className="complete-payroll-message">
            <div className="message-icon">
              <Icon name="check-circle" size={48} />
            </div>
            <p>
              This will submit the payroll for approval. An approver must review
              and approve before it is finalized. Time records for this period
              will be locked while the run is pending.
            </p>
            {payrollRun && (
              <div className="payroll-summary-info">
                <div className="info-item">
                  <span className="info-label">Run ID:</span>
                  <span className="info-value">{payrollRun.runId}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Total Employees:</span>
                  <span className="info-value">{summaryTotals?.totalEmployees || 0}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Total Net Pay:</span>
                  <span className="info-value">
                    ₱{(summaryTotals?.totalNet || 0).toLocaleString('en-PH', { minimumFractionDigits: 2 })}
                  </span>
                </div>
              </div>
            )}
          </div>

          {status && (
            <div className={`status-message ${status.includes('Failed') || status.includes('Error') ? 'error' : 'success'}`}>
              {status}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <div className="modal-actions" style={{ width: '100%', justifyContent: 'flex-end' }}>
            <button
              className="btn-cancel"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              className="btn-confirm"
              onClick={handleOK}
              disabled={loading}
              style={{ minWidth: '120px' }}
            >
              {loading ? 'Submitting...' : 'Submit for Approval'}
            </button>
          </div>
        </div>
    </Modal>
  );
};

export default CompletePayrollModal;
